import React from 'react'
import styled from 'styled-components'
import { Flex, Tooltip } from '@sketch/components'
import Attribute, { Label, Value } from '../Attribute'
import { useHandleCopyValue, CopiableArea } from '@sketch/modules-common'
import DirtyIconTooltip from '../Style/DirtyIconTooltip'

const TypefaceValue = styled(Value)`
  white-space: normal;
`

interface TextAttributeProps {
  label: string
  value: string
  copyValue?: string
  dirtyAttributes?: { originalValue: string; originalProperty: string }
}

const TextAttribute = ({
  label,
  value,
  copyValue,
  dirtyAttributes,
}: TextAttributeProps) => {
  const {
    handleCopyValue,
    copyTooltipText,
    handleEnterCopiableArea,
    handleLeaveCopiableArea,
    copyTooltipVisible,
  } = useHandleCopyValue(copyValue ?? value)

  return (
    <CopiableArea
      onClick={handleCopyValue}
      onMouseEnter={handleEnterCopiableArea}
      onMouseLeave={handleLeaveCopiableArea}
    >
      <Tooltip
        placement="left"
        spacing="10px"
        visible={copyTooltipVisible}
        content={copyTooltipText}
      >
        <Attribute noCopy style={{ width: '100%' }}>
          <Label>
            <Flex alignItems="center">
              {/* the extra handleEnterCopiableArea is to make sure the copy tooltip is triggered after leaving the dirty icon tooltip */}
              <div
                aria-hidden
                onMouseEnter={
                  dirtyAttributes ? handleEnterCopiableArea : undefined
                }
              >
                {label}
              </div>
              {dirtyAttributes && (
                <DirtyIconTooltip
                  originalProperty={dirtyAttributes.originalProperty}
                  originalValue={dirtyAttributes.originalValue}
                  preventLabelTooltip={handleLeaveCopiableArea}
                  isTextStyle
                />
              )}
            </Flex>
          </Label>
          <TypefaceValue
            label={label}
            onMouseEnter={dirtyAttributes ? handleEnterCopiableArea : undefined}
          >
            {value}
          </TypefaceValue>
        </Attribute>
      </Tooltip>
    </CopiableArea>
  )
}

export default TextAttribute
